module.exports = __webpack_public_path__ + "media/creativeMedia/panel07Landscape-96b9c083.png";